import { WritersContainer } from "@/containers";

export const WritersPage = () => {
  return <WritersContainer />;
};
